// admin.guard.ts

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { LogedInUserService } from "../Services/loged-in-user.service";
import { ROLE } from "../Utils/const";

@Injectable({
  providedIn: "root",
})
export class SuperAdminGuard  {
  constructor(
    private logedInUserService: LogedInUserService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAdmin();
  }

  async checkAdmin(): Promise<boolean> {
    const logedInUser = await this.logedInUserService.getAdmin();
    const isAdmin = logedInUser.roleId.some((id) => {
      return Object.values(ROLE[6])[0] === id;
    });

    if (isAdmin) {
      return true;
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}
